import { InvitationSuccess } from 'components/invitationScreen/Success';
import { InvitationScreenLayout } from 'layout/inviteLayout';

export const InvitationSuccessScreen = () => {
	return (
		<InvitationScreenLayout>
			<InvitationSuccess />
		</InvitationScreenLayout>
	);
};
